import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './plugins/clipboard'
import './plugins/element'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
// Vue.config.productionTip = false

import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.use(SlideVerify)


import tinymce from 'tinymce';
Vue.prototype.$tinymce = tinymce;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')